// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { convertDMStoDD } from 'helpers/coordsConversion'
import { castToFloat } from 'helpers/reduxFormFunctions'
import { MUST_SEARCH_AT_LEAST_ONE_VALUE } from 'errors'

import {
  assembleQuery,
  fetchSitesByQuery,
  makeSearchObject,
} from 'helpers/api'

const fetchData = ({ formValues }) => {
  // NOTE  - pathStatus of 'Finalized' hard coded here. (pathStatusId of 2)
  // TODO - would it be better if we searched against pathStatusId instead?
  // we only want to include sites which are finalized in the results here.
  // we don't want to look at non-finalized stuff
  const search = [{
    field: 'pathStatus',
    operator: 'EQ',
    value: 'Finalized',
  }]
  const d = { ...formValues }

  // form must have at least one value
  // throws error message if false
  let hasValue = false

  // capture coords values
  // do this instead of checking for d.latitude/d.longitude
  // because invalid formats are caught by convertDMStoDD
  const latitude = convertDMStoDD(d.latitude)
  const longitude = convertDMStoDD(d.longitude)

  // if there's a set of coords, we have enough to search by
  if (latitude && longitude) {
    // convert the form's radius value to int.
    // if r is not null, that means it wasn't an empty string.
    // then multiply r by 1000. (UI asks for km but API wants meters)
    // otherwise,
    // if r IS null, that means it was an empty string and
    // we want to default the radius search range to 400m
    const radius = (() => {
      const r = castToFloat(d.radius)
      return (
        r !== null
          ? r * 1000
          : 400
      )
    })()

    search.push({
      field: 'geosearch',
      latitude,
      longitude,
      operator: 'EQ',
      value: radius,
    })

    hasValue = true
  }

  // get all the contact ids from the contact input field
  if (d.contactId.length) {
    const contactId = d.contactId.map(d => d.contactId).join(',')

    search.push({
      field: 'contactId',
      operator: 'EQ',
      value: contactId,
    })

    hasValue = true
  }

  // remove these values from 'd' so they're not in
  // the loop below, they are handled separately above.
  delete d.longitude
  delete d.latitude
  delete d.radius
  delete d.contactId

  // iterate through the remaining keys (asr, callSign and siteName)
  Object.keys(d).forEach(k => {
    if (!d[k]) {
      return
    }

    if (!hasValue) {
      hasValue = true
    }

    // all these fields can use the search operator LIKE.
    // so don't worry about specifying here
    const s = makeSearchObject(k, d[k])
    search.push(s)
  })

  if (!hasValue) {
    throw new Error(MUST_SEARCH_AT_LEAST_ONE_VALUE)
  }

  const query = [{
    field: 'search',
    value: search,
  }]

  return fetchSitesByQuery(assembleQuery(query))
}

export default fetchData
